const data = {
    title: 'Начало вашей истории успеха',
    lead: 'Универсальных ответов не существует, а чтобы найти свой ответ и начать личную историю успеха, никак не обойтись без финансовой грамотности. Пройдите наш тест и проверьте, насколько вы разбираетесь в этой теме.',
    __lead: 'Пандемия разогнала инфляцию во всем мире, обострив для миллиардов людей вечные вопросы: как сохранить и приумножить свои сбережения? Как выбрать подходящие финансовые инструменты из огромного множества? Как найти разумный баланс между рисками и выгодами? Универсальных ответов не существует, а чтобы найти свой ответ и начать личную историю успеха, никак не обойтись без финансовой грамотности. Пройдите наш тест и проверьте, насколько вы разбираетесь в этой теме.',
    decorationKey: 'coins',
    shareCTA: 'Поделиться результатом в соцсетях:',
    links: {
        vtb: 'https://bit.ly/3y3VdmW',
        gazeta: 'https://www.gazeta.ru/'
    },
    quiz: {
        start: 'Пройти тест',
        restart: 'Пройти еще раз',
        next: 'Следующий вопрос',
        displayResult: 'Узнать результат',
        questions: [
            {
                id: 'q-0',
                text: 'Откуда вы возьмете начальный капитал для игры на фондовом рынке, если есть лишь три варианта?',
                options: [
                    {
                        id: 'q-0-op-0',
                        label: 'Продам семейную реликвию'
                    },
                    {
                        id: 'q-0-op-1',
                        label: 'Возьму кредит'
                    },
                    {
                        id: 'q-0-op-2',
                        label: 'Займу у друга'
                    }
                ]
            },
            {
                id: 'q-1',
                text: 'Какие отрасли вы предпочтете для инвестиций?',
                options: [
                    {
                        id: 'q-1-op-0',
                        label: 'Те, в которых сегодня наибольший рост'
                    },
                    {
                        id: 'q-1-op-1',
                        label: 'Те, в которых сегодня резкий спад'
                    },
                    {
                        id: 'q-1-op-2',
                        label: 'Те, в которых немного разбираюсь'
                    }
                ]
            },
            {
                id: 'q-2',
                text: 'У вас есть крупная сумма, которая вам понадобится только через год. Что предпочтете сделать сейчас?',
                options: [
                    {
                        id: 'q-2-op-0',
                        label: 'Открою срочный банковский вклад'
                    },
                    {
                        id: 'q-2-op-1',
                        label: 'Вложу в криптовалюту'
                    },
                    {
                        id: 'q-2-op-2',
                        label: 'Куплю золото'
                    }
                ]
            },
            {
                id: 'q-3',
                text: 'Как вы думаете, на какую максимальную годовую доходность по вкладу можно рассчитывать в надежном банке?',
                options: [
                    {
                        id: 'q-3-op-0',
                        label: '5%'
                    },
                    {
                        id: 'q-3-op-1',
                        label: '7%'
                    },
                    {
                        id: 'q-3-op-2',
                        label: '9%'
                    }
                ]
            },
            {
                id: 'q-4',
                text: 'Какой из этих финансовых инструментов вы выберете?',
                options: [
                    {
                        id: 'q-4-op-0',
                        label: 'Тот, который гарантированно принесет $200 за год'
                    },
                    {
                        id: 'q-4-op-1',
                        label: 'Тот, который с вероятностью 50% принесет $2000 и с вероятностью 50% не принесет ничего'
                    },
                    {
                        id: 'q-4-op-2',
                        label: 'Тот, который с вероятностью 80% принесет $5000 и с вероятностью 20% принесет убыток в $3000'
                    }
                ]
            },
            {
                id: 'q-5',
                text: 'Играя на фондовом рынке, вы заработали 1 млн рублей. Вы хотите вывести 200 тысяч рублей. Какую сумму удержат с вас в виде налога?',
                options: [
                    {
                        id: 'q-5-op-0',
                        label: '26 000 рублей'
                    },
                    {
                        id: 'q-5-op-1',
                        label: '130 000 рублей'
                    },
                    {
                        id: 'q-5-op-2',
                        label: 'Налог на операции с ценными бумагами не взимается'
                    }
                ]
            },
            {
                id: 'q-6',
                text: 'Какой из этих активов является самым неликвидным?',
                options: [
                    {
                        id: 'q-6-op-0',
                        label: 'Акции'
                    },
                    {
                        id: 'q-6-op-1',
                        label: 'Криптовалюты'
                    },
                    {
                        id: 'q-6-op-2',
                        label: 'Недвижимость'
                    }
                ]
            }
        ],
        startWithScore: 100,
        map: {
            'q-0-op-0': 100,
            'q-0-op-1': -50,
            'q-0-op-2': -100,
            'q-1-op-0': 0,
            'q-1-op-1': -100,
            'q-1-op-2': 100,
            'q-2-op-0': 100,
            'q-2-op-1': -100,
            'q-2-op-2': 0,
            'q-3-op-0': -100,
            'q-3-op-1': 0,
            'q-3-op-2': 100,
            'q-4-op-0': 0,
            'q-4-op-1': 100,
            'q-4-op-2': -100,
            'q-5-op-0': 0,
            'q-5-op-1': 100,
            'q-5-op-2': -100,
            'q-6-op-0': 0,
            'q-6-op-1': 0,
            'q-6-op-2': 100
        },
        comments: {
            'q-0-op-0': 'Это верное решение, если выбирать из предложенных вариантов. Как бы ни жаль было расставаться с реликвией, но золотое правило инвестора гласит, что инвестировать можно только собственные деньги',
            'q-0-op-1': 'Плохая идея. На фондовом рынке всегда есть вероятность потерять вложенное, поэтому инвестировать следует только собственные сбережения',
            'q-0-op-2': 'Плохая идея. Инвестировать следует только собственные сбережения. А заняв у друга, вы рискуете потерять не только деньги, но и друга',
            'q-1-op-0': 'Рост, если для него нет оснований, может смениться падением. А чтобы понимать, есть ли основания для дальнейшего роста, нужно смотреть не только на котировки акций, но и разбираться в отрасли',
            'q-1-op-1': 'Надеетесь купить задешево, а потом продать задорого? Чтобы такие предположения были обоснованными, нужно не только смотреть на котировки, но и разбираться, что происходит в отрасли',
            'q-1-op-2': 'Верно. Понимание того, что происходит в отрасли, необходимо, чтобы строить обоснованные прогнозы движений на фондовом рынке',
            'q-2-op-0': 'Это разумное решение. Банковский вклад поможет вам сохранить и приумножить сбережения',
            'q-2-op-1': 'Рынок криптовалют очень волатилен. Возможен его рост в долгой перспективе, но никто не знает, что будет с курсами через год, когда вам понадобятся деньги. Не исключены большие потери',
            'q-2-op-2': 'Золото считается надежным активом, но все-таки это биржевой товар, цены на который могут и падать. Поэтому возможны потери, когда вам понадобятся ваши деньги',
            'q-3-op-0': 'Это ближе к средней ставке. Есть и более выгодные предложения',
            'q-3-op-1': 'Ставки в последнее время растут, но и 7% – это уже не самое высокое значение. Есть и более выгодные предложения',
            'q-3-op-2': 'Именно такую доходность обещает ВТБ при открытии вклада "История успеха" с учетом акции «Время-деньги» и подключенной опцией «Сбережения». Минимальная сумма вклада – от 30 тыс рублей. Вклад можно открыть в мобильном или интернет-банке',
            'q-4-op-0': 'Гарантии – это, конечно, хорошо. Но стоит ли игра свеч? Ощутимы ли $200 в вашем годовом бюджете? Не потеряете ли вы больше на сопутствующих издержках?',
            'q-4-op-1': '50% – неплохой шанс, конечно, стоит попробовать, тем более, что никаких рисков не предвидится',
            'q-4-op-2': 'Это рискованное решение, вы слишком надеетесь на удачу, а она может изменить, что приведет к серьезным потерям',
            'q-5-op-0': 'Нет. Налог на операции с ценными бумагами для резидентов РФ составляет 13% (если сумма налоговых баз менее 5 млн рублей), но взимается сразу со всей прибыли на момент вывода средств со счета. То есть 1 000 000*0,13=130 000 рублей',
            'q-5-op-1': 'Правильно. Налог на операции с ценными бумагами для резидентов РФ составляет 13% (если сумма налоговых баз менее 5 млн рублей) и взимается при выводе средств со счета, причем сразу со всей прибыли на момент вывода. То есть 1 000 000*0,13=130 000 рублей',
            'q-5-op-2': 'Еще как взимается. Причем именно при выводе средств со счета и сразу со всей прибыли на момент вывода. То есть 1 000 000*0,13=130 000 рублей',
            'q-6-op-0': 'У акций высокая ликвидность – их всегда можно продать по рыночной цене',
            'q-6-op-1': 'У криптовалют высокая ликвидность – их всегда можно продать по рыночной цене',
            'q-6-op-2': 'Верно. Обычно требуется время, чтобы продать недвижимость, если только не делать существенную скидку покупателю'
        },
        results: [
            {
                key: 'starterResult',
                decorationKey: 'arrow',
                min: 0,
                max: 2,
                direction: -1,
                title: 'На стартовой линии',
                text: 'Ваша финансовая грамотность оставляет желать лучшего. Но никогда не поздно начинать. Читайте финансовые новости, советы начинающим инвесторам, следите за котировками, анализируйте и делайте свои выводы. Помните, что банковский вклад – это по большинству параметров самый надежный инструмент для новичка. Не пропустите новое и привлекательное предложение – вклад «История успеха» от ВТБ с доходностью до 9% годовых для новых клиентов.',
                meta: {
                    path: 'share_result1.html',
                    title: 'На стартовой линии',
                    description: 'Ваша финансовая грамотность оставляет желать лучшего. Но никогда не поздно начинать',
                    image: 'vtb3-newshare_result_1.jpg'
                }
            },
            {
                key: 'learnerResult',
                decorationKey: 'flag',
                min: 3,
                max: 5,
                direction: 0,
                title: 'На пути к успеху',
                text: 'Вы имеете базовые познания, но не стоит останавливаться на этом. Знания помогут вам сделать правильный выбор, сохранив и приумножив сбережения. Не пропустите один из новых и привлекательных финансовых инструментов – вклад «История успеха» от ВТБ с доходностью до 9% годовых для новых клиентов.',
                meta: {
                    path: 'share_result2.html',
                    title: 'На пути к успеху',
                    description: 'Вы имеете базовые познания, но не стоит останавливаться на этом',
                    image: 'vtb3-newshare_result_2.jpg'
                }
            },
            {
                key: 'expertResult',
                decorationKey: 'wallet',
                min: 6,
                max: 7,
                direction: 1,
                title: 'Финансовый гуру',
                text: 'Кажется, вы знаете, как сохранить и приумножить свои сбережения. Но все течет, все меняется, арсенал финансовых инструментов подлежит периодической ревизии. Не пропустите новое и привлекательное предложение – вклад «История успеха» от ВТБ с доходностью до 9% годовых для новых клиентов.',
                meta: {
                    path: 'share_result3.html',
                    title: 'Финансовый гуру',
                    description: 'Кажется, вы знаете, как сохранить и приумножить свои сбережения',
                    image: 'vtb3-newshare_result_3.jpg'
                }
            }
        ]
    }
};

module.exports = data;
